@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.page {
  height: 100vh;
  width: 100vw;
  opacity: 1;
  background: url('https://res.cloudinary.com/almanac/image/upload/v1725884890/blaze_assets/backgrounds/first_time_experience/heroes_nykr9o.png')
    lightgray 50% / cover no-repeat;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .imgContainer {
    border-radius: 20px 20px 0 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.8) 100%),
      url('https://res.cloudinary.com/almanac/image/upload/v1731509756/blaze_assets/annual_upgrade/heroes_posing_nzocha.png')
        lightgray 0px -20.96px / 100% 113.185% no-repeat;
    background-size: cover;
    background-position: center;
    height: 244px;
    position: relative;

    &.success {
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.8) 100%),
        url('https://res.cloudinary.com/almanac/image/upload/v1731521796/blaze_assets/annual_upgrade/car_with_bow_tsix6z.png')
          lightgray 0px -20.96px / 100% 113.185% no-repeat;
    }

    h1.header {
      @include xxl-sohne;
      bottom: 0;
      color: var(--light-100);
      font-weight: 600;
      padding: 20px;
      position: absolute;
      text-shadow: 0px 0px 7px rgba(0, 0, 0, 0.35);
    }
  }

  .description {
    padding: 0px 20px 0 20px;

    .bold {
      font-weight: 700;
    }
  }

  .successMessageContent {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0px 20px 0 20px;

    .link {
      color: var(--selected-fill);
    }
  }
}

.footerRightSlot {
  align-items: center;
  display: flex;
  gap: 14px;

  .prices {
    align-items: center;
    display: flex;
    gap: 6px;

    span:first-child {
      text-decoration: line-through;
    }
  }
}

.carWithBowImg {
  border-radius: 8px;
  width: 520px;
}

.toast {
  border-radius: 12px;
  background: linear-gradient(0deg, #e8099c 0%, #f9f 100%);
  box-shadow: 0px 8px 37px 0px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(25px);
}
